module.exports = __webpack_public_path__ + "media/img/payments/header-mobile-83ddd8509a67b719ce9692c01dbdebf3.jpg";